let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("44HfO")).then(() => parcelRequire('b9lqV'));